export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/countdown.worker.3d5b0927.worker.js");
}
